export default __webpack_public_path__ + "static/media/weather.5bf9b4de.png";